import React, { useState, forwardRef, useImperativeHandle, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
//slices
import { Card, CardContent, Divider, Typography } from '@mui/material';
import SelectableThumbnails from '../../../ImageViewerModal/components/ImageInspector/SelectableThumbnails';
import { selectFrameARI } from '../../../../../../../store/slices/reportsSlice';


const Step1SelectFrame = forwardRef(({ roomFrames, allFrames, isMobile }, ref) => {
    const dispatch = useDispatch();

    useImperativeHandle(ref, () => ({ handleSubmit, }));

    const handleSubmit = async () => {
    };

    return (
        <div className="p-6 bg-white">
            <h2 className="text-lg font-bold mb-2">Choose the best frame to describe the issue</h2>

            <p>
                Welcome! You're about to add a new item to your report.
                To get started, choose a frame (a still image) from the list below, that clearly shows the issue or condition you'd like to document. If you initiated this from a specific room, you'll only see frames from that room.
                Once you've selected a frame, press Next to proceed to the next step.
            </p>

            <div className="mt-6 mb-6">
                <Divider className="my-8 mt-4" />
            </div>

            <SelectableThumbnails
                images={roomFrames}
                isMobile={isMobile}
                onSelect={(img) => { dispatch(selectFrameARI({img, imgIndex: allFrames[img][0], frameNum: allFrames[img][1]})); }}
            />
            
        </div>
    );
});

export default Step1SelectFrame;
